import request from '@/utils/request'

/**
 * 获取告警列表
 * @param {Object} params
 * @param {String} params.startTime 开始时间（可选）
 * @param {String} params.endTime 结束时间（可选）
 * @param {Number} params.stationId 电站ID（可选）
 * @param {Number} params.level 告警等级（可选）
 * @param {String} params.description 告警描述(模糊查询)（可选）
 * @param {Number} params.state 告警状态（可选）
 * @param {String} params.type 设备类型（可选）
 * @param {String} params.uuid 设备编码（可选）
 * @param {String} params.alarmCode 告警编码（可选）
 * @param {String} params.code 故障编码（可选）
 * @param {Number} params.pageNum 页码（可选）
 * @param {Number} params.pageSize 每页显示数（可选）
 * @returns
 */
export function getAlertList({ startTime, endTime, stationId, level, description, state, type, uuid, alarmCode, code, pageNum = 1, pageSize = 10 }) {
  return request({
    url: `/dashboard/v3/alarm/alarmList`,
    method: 'get',
    params: {
      startTime,
      endTime,
      stationId: Number(stationId),
      level: level != null && level !== '' ? Number(level) : undefined,
      description,
      state: state != null && state !== '' ? Number(state) : undefined,
      type,
      uuid,
      alarmCode,
      code,
      pageNum,
      pageSize
    }
  })
}

/**
 * 查询全部电站的告警日志
 * @param {Object} params
 * @param {String} [params.lastTimeStart] 最近触发时间开始区间
 * @param {String} [params.lastTimeEnd] 最近触发时间结束区间
 * @param {String} [params.category] 告警分类：SAFETY / INCOME / NORMAL
 * @param {String} [params.stationName] 电站名称（模糊查询）
 * @param {String|Number} [params.stationId] 电站ID
 * @param {String} [params.alarmCode] 告警码
 * @param {String} [params.description] 告警描述（模糊查询）
 * @param {boolean|null} [params.onlyUnrecovered=true] 恢复状态：true仅未恢复，false仅已恢复，null不过滤
 * @param {Number} [params.pageNum=1] 页码
 * @param {Number} [params.pageSize=10] 每页显示数
 * @returns
 */
export function getAllStationAlertList({
  lastTimeStart,
  lastTimeEnd,
  category,
  stationName,
  stationId,
  alarmCode,
  description,
  onlyUnrecovered = true,
  pageNum = 1,
  pageSize = 25
}) {
  return request({
    url: '/dashboard/v3/alarm/allStationAlarmList',
    method: 'get',
    params: {
      lastTimeStart,
      lastTimeEnd,
      category,
      stationName,
      stationId: stationId !== '' && stationId != null ? Number(stationId) : undefined,
      alarmCode,
      description,
      onlyUnrecovered,
      pageNum,
      pageSize
    }
  })
}

/**
 * 导出全部电站的告警日志
 * @param {Object} params 筛选条件，与全站告警日志列表一致
 * @returns
 */
export function exportAllStationAlertList({
  lastTimeStart,
  lastTimeEnd,
  category,
  stationName,
  stationId,
  alarmCode,
  description,
  onlyUnrecovered = true
}) {
  return request({
    url: '/dashboard/v3/alarm/allStationAlarmList/export',
    method: 'get',
    params: {
      lastTimeStart,
      lastTimeEnd,
      category,
      stationName,
      stationId: stationId !== '' && stationId != null ? Number(stationId) : undefined,
      alarmCode,
      description,
      onlyUnrecovered
    },
    responseType: 'blob'
  })
}

/**
 * 导出告警列表
 * @param {Object} params
 * @param {String} params.startTime 开始时间（可选）
 * @param {String} params.endTime 结束时间（可选）
 * @param {Number} params.stationId 电站ID（可选）
 * @param {Number} params.level 告警等级（可选）
 * @param {String} params.description 告警描述(模糊查询)（可选）
 * @param {Number} params.state 告警状态（可选）
 * @param {String} params.type 设备类型（可选）
 * @param {String} params.uuid 设备编码（可选）
 * @param {String} params.alarmCode 告警编码（可选）
 * @param {String} params.code 故障编码（可选）
 * @returns
 */
export function exportAlertList({ startTime, endTime, stationId, level, description, state, type, uuid, alarmCode, code }) {
  return request({
    url: `/dashboard/v3/alarm/alarmList/export`,
    method: 'get',
    params: {
      startTime,
      endTime,
      stationId: stationId ? Number(stationId) : undefined,
      level: level != null && level !== '' ? Number(level) : undefined,
      description,
      state: state != null && state !== '' ? Number(state) : undefined,
      type,
      uuid,
      alarmCode,
      code
    },
    responseType: 'blob'
  })
}

/**
 * 人工确认告警
 * @param {String|Number} alarmId 告警ID
 * @returns
 */
export function manualResetAlarm(alarmId) {
  return request({
    url: `/dashboard/v3/alarm/manual/resetAlarm/${alarmId}`,
    method: 'get'
  })
}

/**
 * 获取告警快速智能分析
 * @param {Object} context 告警上下文
 * @param {String} context.source 来源标识 (alarm_detail)
 * @param {String} context.intent 意图标识 (alarm.analyze_summary)
 * @param {Object} context.context 具体上下文数据
 * @returns {Promise<Object>} 分析结果
 */
export function getAlarmQuickAnalysis(context) {
  return request({
    url: `/dashboard/v3/ops/agent/alarm/quick-analysis`,
    method: 'post',
    data: context
  })
}
